import { Product } from '../types';

export const impressions = (products: Product[], eventName?: string) => {
  const { dataLayer } = window;

  if (!dataLayer) {
    return;
  }

  const newEvent = {
    ecommerce: {
      impressions: products,
    },
  };

  if (eventName) {
    (newEvent as any).event = eventName;
  }

  dataLayer.push({ ecommerce: null });
  dataLayer.push(newEvent);
};
